import React, { useContext, useEffect, useRef, useState } from 'react';
import DwMarker from '@components/common/DwMarker';
import ProductLink from '@stone/components/common/ProductLink';
import { useTranslation } from 'react-i18next';
import ProductTilesListContext from '@stone/scripts/contexts/ProductTilesListContext';
import { getColorVariations } from '@common/utils/product';
import classNames from 'classnames';
import ProductTileVisual from './ProductTileVisual';
import ProductPrice from './ProductPrice';
import { handleTileNavigation } from '@common/utils/useMousePosition';
import useMediaQueries from '@stone/hooks/useMediaQueries';
import { useLangChecker } from '@common/utils/i18n';
const ProductTileSimple = (props) => {
    var _a, _b;
    const productObject = typeof props.product === 'string' ? JSON.parse(props.product) : props.product;
    // ANCHOR - HOOKS --------------------------------------------------------------------
    const { t } = useTranslation();
    const analyticsContext = useContext(ProductTilesListContext);
    const tileRef = useRef(null);
    const { status, navigation } = handleTileNavigation(tileRef);
    const { isWideDesktop } = useMediaQueries();
    // ANCHOR - STATE --------------------------------------------------------------------
    const [product, setProduct] = useState();
    const [currentColor, setCurrentColor] = useState();
    const [initialColor, setInitialColor] = useState();
    const [originalUuid, setOriginalUuid] = useState(null);
    const [tileState, setTileState] = useState('QUIET');
    const [isOver, setIsOver] = useState(false);
    // ANCHOR - USE EFFECT --------------------------------------------------------------------
    useEffect(() => {
        setProduct(productObject);
        const colorVariations = getColorVariations(productObject);
        const selectedColor = colorVariations.find((v) => v.selected) || colorVariations[0];
        setCurrentColor(selectedColor);
        if (!initialColor)
            setInitialColor(selectedColor);
    }, [props.product]);
    useEffect(() => {
        if (!originalUuid && productObject) {
            setOriginalUuid(productObject.uuid);
        }
    }, [productObject, originalUuid]);
    useEffect(() => {
        if (navigation === 'mouse') {
            if (status === 'IN') {
                setIsOver(true);
                if (tileState === 'QUIET') {
                    setTileState('LIVELY');
                }
            }
            else {
                setIsOver(false);
                if (isWideDesktop && tileState != 'QUIET') {
                    setTileState('QUIET');
                }
                else if (!isWideDesktop && tileState != 'LIVELY') {
                    setTileState('LIVELY');
                }
            }
        }
    }, [status, navigation]);
    // ANCHOR - COMPONENTS --------------------------------------------------------------------
    const tilePrice = () => {
        return (!props.hideprice && (React.createElement("span", { className: "product-tile__price" },
            React.createElement(ProductPrice, { price: product === null || product === void 0 ? void 0 : product.price, promotions: product === null || product === void 0 ? void 0 : product.promotions, inline: true }))));
    };
    const productName = () => {
        const Heading = (props.headingLevel ? props.headingLevel : 'h3');
        return (React.createElement(Heading, { className: 'product-tile__name' },
            React.createElement(ProductLink, { id: `${product.uuid}_link`, isShelf: props.isShelf, noClickTracking: props.noClickTracking, index: props.index, product: product, pageType: props.pageType, className: "product-tile__link", recommender: props === null || props === void 0 ? void 0 : props.recommender, actionList: props.actionList, analyticsData: analyticsContext === null || analyticsContext === void 0 ? void 0 : analyticsContext.analyticsData, ariaHidden: props.showCTA ? true : undefined, tabIndex: props.showCTA || props.disableFocus ? -1 : undefined },
                React.createElement("span", { dangerouslySetInnerHTML: { __html: product.productName } }))));
    };
    const productCTA = () => {
        return (React.createElement(ProductLink, { id: `${product.uuid}_link`, isShelf: props.isShelf, noClickTracking: props.noClickTracking, index: props.index, product: product, pageType: props.pageType, className: "button button--tertiary product-cta", recommender: props === null || props === void 0 ? void 0 : props.recommender, actionList: props.actionList, analyticsData: analyticsContext === null || analyticsContext === void 0 ? void 0 : analyticsContext.analyticsData, tabIndex: props.disableFocus ? -1 : undefined },
            React.createElement("span", { ref: useLangChecker }, t('button.shopnow'))));
    };
    const productSEOName = () => {
        return (product === null || product === void 0 ? void 0 : product.seoName) && React.createElement("p", { className: "product-tile__seoname" }, product.seoName);
    };
    const productInfo = () => {
        return (React.createElement("div", { className: classNames('product-tile__info', 'single-slide__labels') },
            React.createElement("div", { className: "product-tile__info_content" },
                React.createElement("div", { className: "product-tile__info_base" },
                    React.createElement("div", null,
                        productName(),
                        !props.hideSeoName && productSEOName()),
                    props.showCTA && productCTA()),
                !window.unshoppable && !props.hidePrice && React.createElement(React.Fragment, null, tilePrice()))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { "data-id": `${currentColor ? currentColor.productId : ''}`, "data-product": product === null || product === void 0 ? void 0 : product.id, className: classNames('product-tile', 'single-slide__img', 'product-tile--SIMPLE'), ref: tileRef, tabIndex: -1, "aria-hidden": props.disableFocus }, product ? (React.createElement(React.Fragment, null,
            React.createElement(DwMarker, { type: "product", uuid: product.uuid }),
            React.createElement("div", { className: "product-tile__card" },
                React.createElement("div", { className: "product-tile__image-wrapper" },
                    React.createElement(ProductLink, { isShelf: false, noClickTracking: props.noClickTracking, index: props.index, product: product, pageType: props.pageType, className: "product-tile__link", ariaLabel: product.productName + ' ' + ((_b = (_a = product === null || product === void 0 ? void 0 : product.price) === null || _a === void 0 ? void 0 : _a.sales) === null || _b === void 0 ? void 0 : _b.formatted), recommender: props === null || props === void 0 ? void 0 : props.recommender, ariaHidden: true, tabIndex: -1, actionList: props.actionList, originalUuid: originalUuid, tileRef: tileRef, analyticsData: analyticsContext === null || analyticsContext === void 0 ? void 0 : analyticsContext.analyticsData },
                        React.createElement(ProductTileVisual, { product: product, tileType: props.type, isOver: isOver, customImage: props.customImage })))),
            productInfo())) : (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "product-tile__card" },
                React.createElement("div", { className: "product-tile__link" },
                    React.createElement("div", { className: "product-tile__image-wrapper" },
                        React.createElement("div", { className: "product-image" })))),
            !props.hidelabels && (React.createElement("div", { className: "product-tile__info single-slide__labels" },
                React.createElement("p", { className: "product-tile__name" }, t('label.loading')),
                !props.hideprice && React.createElement("span", { className: "product-tile__price" }, t('label.loading')))))))));
};
export default ProductTileSimple;
